export const CVSS_METRICS = {
  4: {
    Base: {
      AV: {
        name: 'Attack Vector',
        data: {
          N: 'Network',
          A: 'Adjacent',
          L: 'Local',
          P: 'Physical',
        },
      },
      AC: {
        name: 'Attack Complexity',
        data: {
          L: 'Low',
          H: 'High',
        },
      },
      AT: {
        name: 'Attack Requirements',
        data: {
          N: 'None',
          P: 'Present',
        },
      },
      PR: {
        name: 'Privileges Required',
        data: {
          N: 'None',
          L: 'Low',
          H: 'High',
        },
      },
      UI: {
        name: 'User Interaction',
        data: {
          N: 'None',
          P: 'Passive',
          A: 'Active',
        },
      },
      VC: {
        name: 'Confidentiality',
        data: {
          H: 'High',
          L: 'Low',
          N: 'None',
        },
      },
      VI: {
        name: 'Integrity',
        data: {
          H: 'High',
          L: 'Low',
          N: 'None',
        },
      },
      VA: {
        name: 'Availability',
        data: {
          H: 'High',
          L: 'Low',
          N: 'None',
        },
      },
      SC: {
        name: 'Subsequent Confidentiality',
        data: {
          H: 'High',
          L: 'Low',
          N: 'None',
        },
      },
      SI: {
        name: 'Subsequent Integrity',
        data: {
          H: 'High',
          L: 'Low',
          N: 'None',
        },
      },
      SA: {
        name: 'Subsequent Availability',
        data: {
          H: 'High',
          L: 'Low',
          N: 'None',
        },
      },
    },
    Threat: {
      E: {
        name: 'Exploit Maturity',
        data: {
          X: 'Not Defined',
          L: 'Low',
          M: 'Medium',
          H: 'High',
        },
      },
    },
  },
  '3.1': {
    Base: {
      AV: {
        name: 'Attack Vector',
        data: {
          N: 'Network',
          A: 'Adjacent',
          L: 'Local',
          P: 'Physical',
        },
      },
      AC: {
        name: 'Attack Complexity',
        data: {
          L: 'Low',
          H: 'High',
        },
      },
      PR: {
        name: 'Privileges Required',
        data: {
          N: 'None',
          L: 'Low',
          H: 'High',
        },
      },
      UI: {
        name: 'User Interaction',
        data: {
          N: 'None',
          R: 'Required',
        },
      },
      S: {
        name: 'Scope',
        data: {
          U: 'Unchanged',
          C: 'Changed',
        },
      },
      C: {
        name: 'Confidentiality',
        data: {
          N: 'None',
          L: 'Low',
          H: 'High',
        },
      },
      I: {
        name: 'Integrity',
        data: {
          N: 'None',
          L: 'Low',
          H: 'High',
        },
      },
      A: {
        name: 'Availability',
        data: {
          N: 'None',
          L: 'Low',
          H: 'High',
        },
      },
    },
    Temporal: {
      E: {
        name: 'Exploit Code Maturity',
        data: {
          X: 'Not Defined',
          U: 'Unproven',
          P: 'Proof-of-Concept',
          F: 'Functional',
          H: 'High',
        },
      },
      RL: {
        name: 'Remediation Level',
        data: {
          X: 'Not Defined',
          O: 'Official Fix',
          T: 'Temporary Fix',
          W: 'Workaround',
          U: 'Unavailable',
        },
      },
      RC: {
        name: 'Report Confidence',
        data: {
          X: 'Not Defined',
          U: 'Unknown',
          R: 'Reasonable',
          C: 'Confirmed',
        },
      },
    },
  },
  3: {
    Base: {
      AV: {
        name: 'Attack Vector',
        data: {
          N: 'Network',
          A: 'Adjacent',
          L: 'Local',
          P: 'Physical',
        },
      },
      AC: {
        name: 'Attack Complexity',
        data: {
          L: 'Low',
          H: 'High',
        },
      },
      PR: {
        name: 'Privileges Required',
        data: {
          N: 'None',
          L: 'Low',
          H: 'High',
        },
      },
      UI: {
        name: 'User Interaction',
        data: {
          N: 'None',
          R: 'Required',
        },
      },
      S: {
        name: 'Scope',
        data: {
          U: 'Unchanged',
          C: 'Changed',
        },
      },
      C: {
        name: 'Confidentiality',
        data: {
          N: 'None',
          L: 'Low',
          H: 'High',
        },
      },
      I: {
        name: 'Integrity',
        data: {
          N: 'None',
          L: 'Low',
          H: 'High',
        },
      },
      A: {
        name: 'Availability',
        data: {
          N: 'None',
          L: 'Low',
          H: 'High',
        },
      },
    },
    Temporal: {
      E: {
        name: 'Exploit Code Maturity',
        data: {
          X: 'Not Defined',
          U: 'Unproven',
          P: 'Proof-of-Concept',
          F: 'Functional',
          H: 'High',
        },
      },
      RL: {
        name: 'Remediation Level',
        data: {
          X: 'Not Defined',
          O: 'Official Fix',
          T: 'Temporary Fix',
          W: 'Workaround',
          U: 'Unavailable',
        },
      },
      RC: {
        name: 'Report Confidence',
        data: {
          X: 'Not Defined',
          U: 'Unknown',
          R: 'Reasonable',
          C: 'Confirmed',
        },
      },
    },
  },
  2: {
    Base: {
      AV: {
        name: 'Access Vector',
        data: {
          L: 'Local',
          A: 'Adjacent Network',
          N: 'Network',
        },
      },
      AC: {
        name: 'Access Complexity',
        data: {
          H: 'High',
          M: 'Medium',
          L: 'Low',
        },
      },
      Au: {
        name: 'Authentication',
        data: {
          M: 'Multiple',
          S: 'Single',
          N: 'None',
        },
      },
      C: {
        name: 'Confidentiality Impact',
        data: {
          N: 'None',
          P: 'Partial',
          C: 'Complete',
        },
      },
      I: {
        name: 'Integrity Impact',
        data: {
          N: 'None',
          P: 'Partial',
          C: 'Complete',
        },
      },
      A: {
        name: 'Availability Impact',
        data: {
          N: 'None',
          P: 'Partial',
          C: 'Complete',
        },
      },
    },
    Temporal: {
      E: {
        name: 'Exploitability',
        data: {
          U: 'Unproven',
          POC: 'Proof-of-Concept',
          F: 'Functional',
          H: 'High',
          ND: 'Not Defined',
        },
      },
      RL: {
        name: 'Remediation Level',
        data: {
          OF: 'Official Fix',
          TF: 'Temporary Fix',
          W: 'Workaround',
          U: 'Unavailable',
          ND: 'Not Defined',
        },
      },
      RC: {
        name: 'Report Confidence',
        data: {
          UC: 'Unconfirmed',
          UR: 'Uncorroborated',
          C: 'Confirmed',
          ND: 'Not Defined',
        },
      },
    },
  },
} as Record<
  string,
  Record<string, Record<string, { name: string; data: Record<string, string> }>>
>;
